import { FormattedMessage } from 'react-intl'

import { CruiseContentSections } from 'constants/cruise'
import useCruiseContentSectionLabels from 'hooks/Cruise/useCruiseContentSectionLabels'
import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import CruiseShipOverview from './CruiseShipOverview'
import CruiseDecksAndCabins from '../DecksAndCabins/CruiseDecksAndCabins'
import CruiseShipAmenities from './CruiseShipAmenities/CruiseShipAmenities'

interface Props {
  offer: App.CruiseOffer
  contentSections: Set<CruiseContentSections>
  reachedTabsSection: boolean
  scrollToPackageOptions: (id: string) => void
}

function CruiseShip({
  offer,
  contentSections,
  reachedTabsSection,
  scrollToPackageOptions,
}: Props) {
  const sectionLabels = useCruiseContentSectionLabels()

  return <LayoutContainer>
    <Pane padding="32 0">
      <Group direction="vertical" gap={56}>
        <Group direction="vertical" gap={48}>
          <Heading
            align="center"
            variant="heading2"
            className="section-title"
          >
            <FormattedMessage
              id="oUDIUShpLiSw9IeczE-h"
              defaultMessage="Ship & Cabins"
              description="Section heading for cruise ship information in the cruise section"
            />
          </Heading>
          <div className="section-content">
            <CruiseShipOverview offer={offer} />
          </div>
        </Group>

        <CruiseShipAmenities ship={offer.ship} />

        {contentSections.has(CruiseContentSections.DECKS_AND_CABINS) && (
          <Group direction="vertical" gap={48}>
            <Heading
              align="center"
              variant="heading2"
              className="section-title"
            >
              {sectionLabels[CruiseContentSections.DECKS_AND_CABINS]}
            </Heading>

            <div className="section-content">
              <CruiseDecksAndCabins
                ship={offer.ship}
                hasGotToOverview={reachedTabsSection}
                showPackageOptions={() => scrollToPackageOptions('dates-and-pricing')}
              />
            </div>
          </Group>
        )}
      </Group>
    </Pane>
  </LayoutContainer>
}

export default CruiseShip
